module.exports = __webpack_public_path__ + "6aff98a3e6b1b1296e5007f27fd0cbd1.png";